var _mask, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_6330_19051",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 23.995C0 10.7429 10.7429 0 23.995 0C37.2471 0 47.99 10.7429 47.99 23.995C47.99 37.2471 37.2471 47.99 23.995 47.99C10.7429 47.99 0 37.2471 0 23.995Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.995C0 10.7429 10.7429 0 23.995 0C37.2471 0 47.99 10.7429 47.99 23.995C47.99 37.2471 37.2471 47.99 23.995 47.99C10.7429 47.99 0 37.2471 0 23.995Z",
    fill: "#F9FAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.995M47.99 23.995M47.99 23.995M0 23.995M23.995 0M47.99 23.995M23.995 47.99M0 23.995M23.995 47.99V46.9417C11.3219 46.9417 1.04825 36.6681 1.04825 23.995H0H-1.04825C-1.04825 37.826 10.164 49.0382 23.995 49.0382V47.99ZM47.99 23.995H46.9417C46.9417 36.6681 36.6681 46.9417 23.995 46.9417V47.99V49.0382C37.826 49.0382 49.0382 37.826 49.0382 23.995H47.99ZM23.995 0V1.04825C36.6681 1.04825 46.9417 11.3219 46.9417 23.995H47.99H49.0382C49.0382 10.164 37.826 -1.04825 23.995 -1.04825V0ZM23.995 0V-1.04825C10.164 -1.04825 -1.04825 10.164 -1.04825 23.995H0H1.04825C1.04825 11.3219 11.3219 1.04825 23.995 1.04825V0Z",
    fill: "#E9E9E9",
    mask: "url(#path-1-inside-1_6330_19051)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9901 33.9929C29.5118 33.9929 33.988 29.5167 33.988 23.995C33.988 18.4733 29.5118 13.9971 23.9901 13.9971C18.4684 13.9971 13.9922 18.4733 13.9922 23.995C13.9922 29.5167 18.4684 33.9929 23.9901 33.9929Z",
    stroke: "#1F1F1F",
    strokeWidth: 1.49969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9922 17.9961V23.9948L27.9914 25.9944",
    stroke: "#1F1F1F",
    strokeWidth: 1.49969,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/time.3168b9d56adbb7e2c6b5a4ba0d3b0420.svg";
export { ForwardRef as ReactComponent };